import { hasOpenCreditNote } from "./creditNote";

export function getEffectivePoStatus(row, activeFilterStatuses) {
  const metaPoStatus = row.metadata?.po_status;
  const orderRowStatus = row.order_status;
  if (activeFilterStatuses && activeFilterStatuses.size > 0) {
    if (metaPoStatus && activeFilterStatuses.has(metaPoStatus)) return metaPoStatus;
    if (orderRowStatus && activeFilterStatuses.has(orderRowStatus)) return orderRowStatus;
  }
  return row.source === "FINS" ? metaPoStatus : orderRowStatus;
}

// Migrated RCS PO codes contain "/" (e.g. PO-LIV-5668-2026-2027/107097), which would
// split the `:po_code` route segment. Encoded, React Router matches it as one segment
// and `useParams` hands readers the decoded code (ENG-28753).
export function getPoDestination(row, effectivePoStatus) {
  const poCode = encodeURIComponent(row.po_code);
  return effectivePoStatus === "revision_requested" && !hasOpenCreditNote(row)
    ? `/dashboard/invoice-management/po/${poCode}/revision`
    : `/dashboard/invoice-management/${poCode}`;
}
